import type { ConfigUser } from '@config/interfaces';
import type { SignIn, SignInTag } from './interfaces';

/** Anything the host does not report as SSO signs in with a password held by the provider. */
export const signIn = (user: ConfigUser): SignIn => (user.signInMethod?.toUpperCase() === 'SSO' ? 'sso' : 'credentials');

export const signInTag = (user: ConfigUser, labels: Record<SignIn, string>): SignInTag => {
  const method = signIn(user);

  return { key: method, value: labels[method] };
};
